export default __webpack_public_path__ + "static/media/lightmeter.2611dc15.png";